import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const SearchUserItem = ({ user, clearUsers }) => {
  return (
    <Fragment>
      <div onClick={() => clearUsers()}>
        {user.role === "innovator" && (
          <Link to={`/${user.channelid}`}>
            <div className="full-result-section" key={user._id}>
              <div className="drop-down-section-name">
                <div className="bar background-green"></div>
                <div className="drop-down-title green">Innovators</div>
                <div className="bar background-green"></div>
              </div>
              <div className="drop-down-result-section">
                <div className="drop-down-result-avi-container">
                  <div className="avi-color-border green">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="drop-down-result-avi"
                    />
                  </div>
                </div>
                <div className="drop-down-result-text-container">
                  <div className="drop-down-result-text">
                    <ul className="result-text-items">
                      <li className="result-text-name-item green">
                        {user.channelid}
                      </li>
                      <li className="result-text-item">
                        {user.firstname} {user.lastname}
                      </li>
                      <li className="result-text-item">{user.jobtitle}</li>
                      <li className="result-text-item">
                        {user.location.city}, {user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        )}
        {user.role === "mentor" && (
          <Link to={`/${user.channelid}`}>
            <div className="full-result-section" key={user._id}>
              <div className="drop-down-section-name">
                <div className="bar background-red"></div>
                <div className="drop-down-title red">Mentors</div>
                <div className="bar background-red"></div>
              </div>
              <div className="drop-down-result-section">
                <div className="drop-down-result-avi-container">
                  <div className="avi-color-border red">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="drop-down-result-avi"
                    />
                  </div>
                </div>
                <div className="drop-down-result-text-container">
                  <div className="drop-down-result-text">
                    <ul className="result-text-items">
                      <li className="result-text-name-item red">
                        {user.channelid}
                      </li>
                      <li className="result-text-item">
                        {user.firstname} {user.lastname}
                      </li>
                      <li className="result-text-item">{user.jobtitle}</li>
                      <li className="result-text-item">
                        {user.location.city}, {user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        )}
        {user.role === "employer" && (
          <Link to={`/${user.channelid}`}>
            <div className="full-result-section" key={user._id}>
              <div className="drop-down-section-name">
                <div className="bar background-blue"></div>
                <div className="drop-down-title blue">Recruiters</div>
                <div className="bar background-blue"></div>
              </div>
              <div className="drop-down-result-section">
                <div className="drop-down-result-avi-container">
                  <div className="avi-color-border blue">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="drop-down-result-avi"
                    />
                  </div>
                </div>
                <div className="drop-down-result-text-container">
                  <div className="drop-down-result-text">
                    <ul className="result-text-items">
                      <li className="result-text-name-item blue">
                        {user.companyname}
                      </li>
                      <li className="result-text-item">{user.channelid}</li>
                      <li className="result-text-item">
                        {user.firstname} {user.lastname}
                      </li>
                      <li className="result-text-item">
                        {user.location.city}, {user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        )}
        {user.role === "company" && (
          <Link to={`/${user.channelid}`}>
            <div className="full-result-section" key={user._id}>
              <div className="drop-down-section-name">
                <div className="bar background-blue"></div>
                <div className="drop-down-title blue">Employers</div>
                <div className="bar background-blue"></div>
              </div>
              <div className="drop-down-result-section">
                <div className="drop-down-result-avi-container">
                  <div className="avi-color-border blue">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="drop-down-result-avi"
                    />
                  </div>
                </div>
                <div className="drop-down-result-text-container">
                  <div className="drop-down-result-text">
                    <ul className="result-text-items">
                      <li className="result-text-name-item blue">
                        {user.employername}
                      </li>
                      <li className="result-text-item">
                        {user.location.city}, {user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        )}
      </div>
    </Fragment>
  );
};

export default SearchUserItem;
